// extracted by mini-css-extract-plugin
export default {"wrapper":"PositionTrackerPage_wrapper__VVWYr"};